let server = process.env.REACT_APP_SERVER || "/api";

/* Seaweed */
export function sendLogs() {
	return `${server}/logs`
}

export function getUserInfo() {
    return `${server}/auth/userInfo`;
}

/* Public Orders */

export function getPublicOrders(projectId, pageSize, pageNumber) {
	return server + `/publicOrders/${projectId}?pageSize=${pageSize}&pageNumber=${pageNumber}`;
}

/* WoP */

export function getPaymentClaims(projectId) {
	return server + `/projects/${projectId}/wop`;
}

/* External Control */

export function getExternalControls(lang) {
	//controls/external/all
	return server + `/controls/search/external?lang=${lang}`;
}

export function getExternalControlsSave() {
	return server + '/external/controls/add';
}

export function getExternalControlsUpdate(controlId) {
	return server + `/external/controls/${controlId}`;
}

export function getExternalControlDetail(controlId,lang) {
	return server + `/externalControlDetail/${controlId}?lang=${lang}`;
}

export function getExternalControlTypeDictionary(lang){
	return server + `/dictionaries/externalControlTypeDictionary?lang=${lang}`;
}

export function getControlConsequenceCorrectionRateDictionary(){
	return server + `/dictionaries/controlConsequenceCorrectionRateDictionary`;
}

export function getControlIdentifierTypeDictionary(lang){
	return server + `/dictionaries/entityIdentifierTypeDictionary?lang=${lang}`;
}

export function getControllingEntitiesDictionary(){
	return server + `/dictionaries/controllingEntitiesDictionary`;
}

export function getControllingEntitiesDictionaryActivate(id){
	return server + `/dictionaries/controllingEntitiesDictionary/${id}/activate`;
}

export function getControllingEntitiesDictionaryDeactivate(id){
	return server + `/dictionaries/controllingEntitiesDictionary/${id}/deactivate`;
}

export function getExternalControlResultDictionary(lang){
	return server + `/dictionaries/externalControlResultDictionary?lang=${lang}`;
}

export function getControlConsequenceTypeDictionary(lang){
	return server + `/dictionaries/controlConsequenceTypeDictionary?lang=${lang}`;
}

export function getPzpControlTypeDictionary(){
	return server + `/dictionaries/pzpControlTypeDictionary`;
}

/* Control */

export function getChangeControlCompleteStatus(controlId) {
    return server + '/control/completed/' + controlId;
}

export function getControlsActive() {
	//zmiana ze starego: '/controls/active/'
	return server + '/controls/search/manage?controlStatus=W_trakcie_realizacji';
}

export function getControlsPlanned() {
	///controls/planned/
	return server + '/controls/search/manage?controlStatus=Planowana';
}

export function getControlById(controlId) {
	return getPostControlDetailByControlId(controlId)
}

export function getPostControlDocumentByControlId(controlId) {
	return server + '/controls/search/my/' + controlId + '/documents'
}

export function getExtenalControlDetailById(controlId, lang) {
	return server + `/externalControlDetail/${controlId}?lang=${lang}`;
}

export function getControlViewById(controlId) {
	return server + '/controlView/' + controlId + '';
}

export function getControlsDone() {
	///controls/done/
	return server + '/controls/search/manage?controlStatus=Zrealizowana';
}

export function getPostControls() {
	//controls/postcontrol/
	return server + '/controls/search/post?';
}

export function getMyControlsActive() {
	//mycontrols/active
	return server + '/controls/search/my?controlStatus=W_trakcie_realizacji';
}

export function getMyControlsPlanned() {
	//mycontrols/planned
	return server + '/controls/search/my?controlStatus=Planowana';
}

export function getMyControlsDone() {
	//mycontrols/done
	return server + '/controls/search/my?controlStatus=Zrealizowana';
}

export function getAddControl() {
	return server + '/controls/add/';
}

export function getEditControl(controlId) {
	return server + '/controls/' + controlId + '/';
}

export function getControlDetails(controlId) {
	return server + '/controls/id/' + controlId;
}

export function getChangeControlStatus(controlId) {
	return server + '/controls/changeStatus/' + controlId + '/';
}

export function getChangeFollowUpStatusInfo(controlId) {
	return server + '/controls/changeFollowUp/' + controlId + '/';
}

export function deleteControl(id) {
	return server + '/control/' + id + '';
}

export function getControlsExistByList(listId) {
	return server + '/control/exist/' + listId + '';
}

export function getEditControlledInfo(controlId) {
	return server + '/controls/controlledInfo/' + controlId + '/';
}

/* List */
export function getLists() {
	return server + '/lists';
}

export function getActiveLists() {
	return server + '/lists/active';
}

export function getList(id) {
	return server + '/list/' + id;
}

export function saveList() {
	return server + '/list/add';
}

export function urlChangeActivationList(id) {
	return server + '/list/changeActivation/' + id + '';
}

export function updateControlListBlock(controlId) {
	return server + '/controlList/answers/' + controlId;
}

export function editList(id) {
	return server + '/list/edit/' + id + '';
}

export function getPrograms() {
	return server + '/programs/';
}

export function getBlocks() {
	return server + '/blocks';
}

export function getBlocksPaged(pageSize, pageNumber) {
	return server + `/blocks?pageSize=${pageSize}&pageNumber=${pageNumber}`;
}

export function getActiveBlocks() {
	return server + '/blocks/active';
}

export function getBlockQuestions(blockId) {
	return server + `/blocks/${blockId}/questions`;
}

export function getActiveBlocksForQuestions() {
	return server + '/blocks/active/questions';
}

export function getControllersUsers() {
	return server + '/users/list';
}

export function getProjects(pageNumber, pageSize, sortBy, sortOrder, projectNumber, beneficiaryName, beneficiaryIdentityNumber, title, globalFilter) {
    let basePath = `${server}/projects`;
    
    const params = new URLSearchParams();
    
	if (pageNumber !== undefined) params.append('pageNumber', pageNumber);
    if (pageSize !== undefined) params.append('pageSize', pageSize);
	if (sortBy) params.append('sortBy', sortBy);
    if (sortOrder) params.append('sortOrder', sortOrder);
    if (projectNumber) params.append('projectNumber', projectNumber);
    if (beneficiaryName) params.append('beneficiaryName', beneficiaryName);
    if (beneficiaryIdentityNumber) params.append('beneficiaryIdentityNumber', beneficiaryIdentityNumber);
    if (title) params.append('title', title);
    if (globalFilter) params.append('globalFilter', globalFilter);
    
    const queryString = params.toString();
    return queryString ? `${basePath}?${queryString}` : basePath;
}

export function getAllProjects(searchText) {
    if (!searchText) {
        return `${server}/projects/all/`;
    }
    return `${server}/projects/all?projectNumber=${encodeURIComponent(searchText)}`;
}

export function getTypes() {
	return server + '/dictionaries/1';
}

export function getModes() {
	return server + '/dictionaries/2';
}

export function getKinds() {
	return server + '/dictionaries/3';
}

export function saveKinds() {
	return `${server}/dictionaries/kinds`
}


export function activateKind(entryId) {
	return `${server}/dictionaries/kinds/${entryId}/activate`
}

export function deactivateKind(entryId) {
	return `${server}/dictionaries/kinds/${entryId}/deactivate`
}

export function getFindingKinds() {
	return server + '/findingKinds';
}

/* Questions */
export function urlQuestions(type, pageSize, pageNumber) {
	return server + `/questions/${type}?pageSize=${pageSize}&pageNumber=${pageNumber}`;
}

export function urlGetQuestion(id) {
	return server + '/question/' + id + '';
}

export function urlAddQuestion() {
	return server + '/question/add';
}

export function urlEditQuestion(id) {
	return server + '/question/' + id + '';
}

export function urlChangeActivationQuestion(id) {
	return server + '/question/changeActivation/' + id + '';
}

export function urlDeleteQuestion(id) {
	return server + '/question/' + id + '';
}

export function getStandardQuestionsByBlock(blockId) {
	return server + '/questions/standard/block/' + blockId + '';
}

export function getQuestionsByBlock(blockId) {
	return server + '/questions/block/' + blockId + '';
}

export function getControlBlockQuestions(controlId, blockId) {
	return server + `/controls/${controlId}/control-lists/blocks/${blockId}/answers`;
}

/* Block */
export function urlAddBlock() {
	return server + '/blocks/add';
}

export function urlEditBlock(id) {
	return server + '/blocks/' + id + '';
}

export function urlChangeActivationBlock(id) {
	return server + '/blocks/changeActivation/' + id + '';
}

export function urlEditLockBlock(controlId, blockId) {
	return server + `/controls/${controlId}/control-lists/blocks/${blockId}/set-edit-lock`;
}

export function urlEditExtendLockBlock(controlId, blockId) {
	return server + `/controls/${controlId}/control-lists/blocks/${blockId}/lock/extend`;
}


export function getPostControlDetailByControlId(controlId) {
	return server + '/controls/details/' + controlId + '';
}

export function getMyControlDetailByControlId(controlId) {
	return server + '/controls/details/myControl/' + controlId + '';
}

export function getCopyPostControlInfo(controlId, id) {
	return `${server}/controls/details/${controlId}/final/postControlInfo/${id}`;
}

export function getCreatePostControlDocument(controlId) {
	//PUT
	return server + '/controls/details/' + controlId + '/edit/postControlDocument'
}

export function getEditPostControlDocument(controlId, id) {
	//POST
	return server + '/controls/details/' + controlId + "/edit/postControlDocument/" + id
}

export function getDeletePostControlDocument(controlId, id) {
	//DELETE
	return server + '/controls/details/' + controlId + "/edit/postControlDocument/" + id
}

export function setAbbrevs(controlId) {
	//POST
	return server + `/post-control-info/${controlId}/set-abbreviations`;
}

export function setLegalBasis(controlId) {
	//POST
	return server + `/post-control-info/${controlId}/set-legal-basis`;
}

export function setControlSubject(controlId) {
	//POST
	return server + `/post-control-info/${controlId}/set-control-subject`;
}

export function setControlPurpose(controlId) {
	//POST
	return server + `/post-control-info/${controlId}/set-control-purpose`;
}

export function setControlSummary(controlId) {
	//POST
	return server + `/post-control-info/${controlId}/set-control-summary`;
}

export function setFinalInstructions(controlId) {
	//POST
	return server + `/post-control-info/${controlId}/set-final-instructions`;
}

export function setAttachments(controlId) {
	//PUT
	return server + `/post-control-info/${controlId}/attachments`;
}

export function addFinding(controlId) {
	//POST
	return server + `/post-control-info/${controlId}/findings`;
}

export function updateFinding(controlId, findingId) {
	//PUT
	return server + `/post-control-info/${controlId}/findings/${findingId}`;
}

export function deleteFinding(controlId, findingId) {
	//DELETE
	return server + `/post-control-info/${controlId}/findings/${findingId}`;
}

export function setCorrections(controlId) {
	//PUT
	return server + `/post-control-info/${controlId}/corrections`;
}

export function setChecklistVersion(controlId) {
	//POST
	return server + `/post-control-info/${controlId}/set-check-list-version`;
}

export function getSendDocumentsDetilsControlInfo(infoId) {
	return server + `/postControlInfo/${infoId}/send`
}
export function getSendDocumentsControlNote(noteId) {
	return server + `/postControlNote/${noteId}/send`;
}

export function getPostControlInfoValidationStatusSave(infoId) {
	return server + '/postControlInfo/validated/' + infoId;
}

export function getControlRemarksInfoSave(infoId) {
	return server + '/postControlInfo/' + infoId + '/objectionStatement';
}

/*
/    Documents and files
*/
export function controlsListXSDownload() {
	return `${server}/controls/search/manage/xlsx`
}

export function fileUpload() {
	return `${server}/files/upload`
}

export function documentFileDownload(fileId) {
	return `${server}/v2/documents/download/${fileId}`
}

export function getControlDocumentsList(containerId) {
	// used in GET
	return `${server}/v2/documents/container/${containerId}`
}

export function addDocument(containerId, saveAsDraft) {
	// used in POST
	return `${server}/v2/documents/container/${containerId}?saveAsDraft=${saveAsDraft || false}`
}

export function removeDocument(documentId, controlUuid) {
	return `${server}/v2/documents/${documentId}/container/${controlUuid}`
}

export function getDocumentsCategoriesDict(lang) {
	return `${server}/dictionaries/documentCategoryDictionary?lang=${lang}`
}

export function getProjectDocumentsList(projectUuid, categoryId) {
	return `${server}/v2/documents/project/${projectUuid}/${categoryId}`
}

export function attachDocumentsToControl(containerId) {
	// used in PUT
	return `${server}/v2/documents/container/${containerId}`
}

/*
/    Messages
*/
export function getSessionTimeEndMessage() {
	return 'Twoja sesja wkrótce wygaśnie. Naciśnij OK, aby przedłużyć sesję.';
}

export function getLogOutMessage() {
	return 'Ze względów bezpieczeństwa zostałeś wylogowany z systemu.';
}

export function getCancelMessage() {
	return 'Ta operacja może spowodować utratę niezapisanych danych. Czy chcesz kontynuować?';
}

export function tooLongTextMessage(limit) {
	return 'Pole nie może być dłuższe niż ' + limit + ' znaków';
}

export function getCreateBlockMessage() {
	return 'Blok został zapisany';
}

export function getActivateBlockMessage() {
	return 'Blok został aktywowany';
}

export function getDeactivateBlockMessage() {
	return 'Blok został dezaktywowany';
}

export function getBlockNameMustBeChosen() {
	return 'Wpisz tytuł bloku';
}

export function getQuestionNameMustBeChosen() {
	return 'Wpisz treść pytania';
}


export function getBlockMustBeChosen() {
	return 'Wybierz co najmniej jeden blok';
}

export function getListNameMustBeChosen() {
	return 'Wpisz nazwę listy';
}

export function getCreateQuestionMessage() {
	return 'Pytanie zostało zapisane';
}

export function getActivateQuestionMessage() {
	return 'Pytanie zostało aktywowane';
}

export function getDeactivateQuestionMessage() {
	return 'Pytanie zostało dezaktywowane';
}

export function createListMessage() {
	return 'Lista została zapisana';
}

export function tooLongListTextMessage() {
	return 'Nazwa listy nie może być dłuższa niż 500 znaków';
}

export function getCantEditListMessage() {
	return 'Nie możesz edytować listy, dla której utworzono kontrolę.';
}

export function getActivateListMessage() {
	return 'Lista została aktywowana';
}

export function getDeactivateListMessage() {
	return 'Lista została dezaktywowana';
}

export function getChangeControlListMessage() {
	return 'Zmiana listy sprawdzającej spowoduje utratę dotychczasowych odpowiedzi na pytania i załączników do aktualnie stosowanej listy sprawdzającej.';
}

export function createControlMessage() {
	return 'Kontrola została zapisana';
}

export function deleteControlConfirmationMessage(number) {
	return 'Czy chcesz usunąć kontrolę ' + number + '?';
}

export function startControlConfirmationMessage(number) {
	return 'Czy chcesz rozpocząć kontrolę ' + number + '?';
}

export function endControlConfirmationMessage(number) {
	return 'Czy chcesz zakończyć kontrolę ' + number + '?';
}

export function restoreControlConfirmationMessage(number) {
	return 'Czy chcesz wznowić kontrolę ' + number + '?';
}

export function startControlMessage() {
	return 'Kontrola została rozpoczęta. Czy chcesz przejść do uzupełnienia listy sprawdzającej?';
}

export function deleteControlMessage() {
	return 'Kontrola została usunięta';
}

export function endControlMessage() {
	return 'Kontrola została zakończona';
}

export function restoreControlMessage() {
	return 'Kontrola została wznowiona';
}

export function saveControlListMessage() {
	return 'Dane w części wstępnej listy zostały zapisane';
}

export function saveControlListBlockMessage() {
	return 'Dane dotyczące bloku listy zostały zapisane';
}

export function saveFollowUpStatusInfoMessage() {
	return 'Dane dotyczące stanu wdrożenia zaleceń zostały zapisane';
}

export function saveRemarksInfoMessage() {
	return 'Dane dotyczące zastrzeżeń zostały zapisane';
}

export function remarksDocumentsValidationMessage() {
	return 'Uzupełnij datę zgłoszenia zastrzeżeń i dodaj plik z zastrzeżeniami lub zaznacz "Nie zgłoszono zastrzeżeń"';
}

export function finalIssueDateValidationMessage() {
	return 'Data rozpatrzenia zastrzeżeń nie może być wcześniejsza niż data wpływu zastrzeżeń.';
}

export function createPostControlInfoMessage() {
	return 'Informacja pokontrolna została zapisana. Czy chcesz przejść do edycji informacji pokontrolnej?';
}

export function createPostControlFinalInfoMessage() {
	return 'Ostateczna informacja pokontrolna została zapisana. Czy chcesz przejść do edycji ostatecznej informacji pokontrolnej?';
}

export function createPostControlNoteMessage() {
	return 'Notatka pokontrolna została zapisana. Czy chcesz przejść do edycji notatki pokontrolnej?';
}

export function savePostControlInfoMessage() {
	return 'Informacja pokontrolna została zapisana';
}

export function savePostControlFinalInfoMessage() {
	return 'Ostateczna informacja pokontrolna została zapisana';
}

export function savePostControlNoteMessage() {
	return 'Notatka pokontrolna została zapisana';
}

export function deletePostControlInfoMessage() {
	return 'Informacja pokontrolna została usunięta';
}

export function deletePostControlFinalInfoMessage() {
	return 'Ostateczna informacja pokontrolna została usunięta';
}

export function deletePostControlNoteMessage() {
	return 'Notatka pokontrolna została usunięta';
}

export function deletePostControlInfoConfirmationMessage() {
	return 'Czy chcesz usunąć informację pokontrolną?';
}

export function deletePostControlFinalInfoConfirmationMessage() {
	return 'Czy chcesz usunąć ostateczną informację pokontrolną?';
}

export function deletePostControlNoteConfirmationMessage() {
	return 'Czy chcesz usunąć notatkę pokontrolną?';
}

export function preparePostControlInfoMessage() {
	return 'Czy chcesz przygotować informację pokontrolną?';
}

export function preparePostControlFinalInfoMessage() {
	return 'Czy chcesz przygotować ostateczną informację pokontrolną?';
}

export function preparePostControlNoteMessage() {
	return 'Czy chcesz przygotować notatkę pokontrolną?';
}

export function deleteFindingConfirmationMessage() {
	return 'Czy chcesz usunąć ustalenie z informacji pokontrolnej?';
}

export function saveCorrectionMessage() {
	return 'Korekta finansowa została zapisana na liście korekt';
}

export function deleteCorrectionConfirmationMessage() {
	return 'Czy chcesz usunąć korektę finansową z listy korekt?';
}

export function deleteAbbrevConfirmationMessage() {
	return 'Czy chcesz usunąć skrót?';
}

export function deleteRecommendationConfirmationMessage() {
	return 'Czy chcesz usunąć zalecenie?';
}

export function deleteCorrectionMessage() {
	return 'Korekta finansowa została usunieta z listy korekt';
}

export function postControlInfoValidatedMessage() {
	return 'Infromacja pokontrolna jest poprawna';
}

export function postControlFinalInfoValidatedMessage() {
	return 'Ostateczna infromacja pokontrolna jest poprawna';
}

export function postControlInfoNotValidatedMessage() {
	return 'Informacja pokontrolna nie została sprawdzona. Wybierz funkcję SPRAWDŹ w widoku informacji pokontrolnej.';
}

export function postControlFinalInfoNotValidatedMessage() {
	return 'Ostateczna informacja pokontrolna nie została sprawdzona. Wybierz funkcję SPRAWDŹ w widoku ostatecznej informacji pokontrolnej.';
}

export function emptyMessage() {
	return 'Uzupełnij wszystkie pola obowiązkowe';
}

export function tooLongQuestionTextMessage(limit) {
	return 'Treść pytania nie może być dłuższa niż ' + limit + ' znaków';
}

export function getDeactivateBlockConfirmMessage() {
	return 'Wszystkie odpowiedzi, uwagi i załączniki w tym bloku zostaną usunięte. Czy chcesz kontynuować?';
}

export function getNotAllBlockFilledOutErrorMessage() {
	return 'Nie wszystkie pytania w blokach zostały uzupełnione';
}

export function getFillControllingEntityMessage() {
	return 'Uzupełnij podmiot kontrolujący';
}

export function getFillControlledPartiesMessage() {
	return 'Uzupełnij podmioty kontrolowane';
}

export function getFillControlPlacesMessage() {
	return 'Uzupełnij miejsca kontroli';
}

export function getDateStartIsGreaterThanEndMessage() {
	return 'Uzupełnij datę rozpoczęcia kontroli';
}

export function getNoFollowUpMessage() {
	return 'Kontrola nie ma zaleceń do monitorowania';
}

export function getNoPostControlDocumentMessage() {
	return 'Kontrola nie ma jeszcze dokumentu pokontrolnego';
}

export function getNoPostControlRemarksMessage() {
	return 'Kontrola nie ma informacji o zastrzeżeniach'
}

export function getProjectNumberMustBeChosenMessage() {
	return 'Wybierz projekt';
}

export function getFindingMustBeChosenMessage() {
	return 'Wybierz ustalenie finansowe';
}

export function getCorrectionKindMustBeChosenMessage() {
	return 'Wybierz rodzaj korekty';
}

export function getMustNumericMessage() {
	return 'Wpisz prawidłową wartość';
}

export function getMustBeGreaterThanZeroMessage() {
	return 'Wartość musi być większa niż 0';
}

export function getRateMustBeFilledOutMessage() {
	return 'Wpisz stawkę korekty';
}

export function getRateMustByBetweenZeroAndHundredMessage() {
	return 'Stawka korekty musi mieć wartość od 0,01 do 100';
}

export function getBaseMustBeFilledOutMessage() {
	return 'Wpisz podstawę korekty';
}

export function getWrongExpenditureMustBeFilledOutMessage() {
	return 'Wpisz wartość wydatków niekwalifikowalnych';
}

export function getBaseMustBeGreaterThanWrongExpenditureMessage() {
	return 'Wydatki niekwalifikowalne nie mogą być większe niż podstawa korekty';
}

export function getCurrentInfluenceMustBeChosenMessage() {
	return 'Wybierz wpływ na wnioski o płatność';
}

export function getFutureInfluenceMustBeChosenMessage() {
	return 'Wybierz wpływ na przyszłe wnioski o płatność';
}

export function getCannotEditControlMessage() {
	return 'Nie można edytować kontroli, która jest realizowana lub zakończona.';
}
